import { render, staticRenderFns } from "./EditAttributesIcon.vue?vue&type=template&id=77a54074"
import script from "./EditAttributesIcon.vue?vue&type=script&lang=ts"
export * from "./EditAttributesIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports